import { render, staticRenderFns } from "./costIncomeReport.vue?vue&type=template&id=50bff052&scoped=true&"
import script from "./costIncomeReport.vue?vue&type=script&lang=js&"
export * from "./costIncomeReport.vue?vue&type=script&lang=js&"
import style0 from "./costIncomeReport.vue?vue&type=style&index=0&id=50bff052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bff052",
  null
  
)

export default component.exports